import React from "react";
import LinkedIn from "../../../assets/Images/linkedin.png";
import Fb from "../../../assets/Images/facebook.png";
import YouTube from "../../../assets/Images/youtube.png";
import Twitter from "../../../assets/Images/twitter.png";
import Instagram from "../../../assets/Images/instagram.png";
import ClassplusLogo from "../../../assets/Images/cp-logo-white.webp";
//import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <img src={ClassplusLogo} alt="" className="footer_logo" />

      {/* <div className="footer_links">
        <Link to="/features">Product</Link>
        <Link to="/tnc"> Terms Of Use</Link>
        <Link to="/policy"> Privacy Policy</Link>
        <Link to="/contactus"> Contact Us</Link>
      </div> */}

      <div className="footer_address">
        <p className="footer_address_head">CONTACT INFO</p>
        <div className="footer_address_content">
          <p className="footer_address_content-one">
            1st Floor, D8, Sector 3, Noida,
          </p>
          <p className="footer_address_content-two">Uttar Pradesh 201301</p>
        </div>
      </div>

      <div className="footer_sm">
        <a
          href="https://www.facebook.com/classplusapp"
          rel="noopener noreferrer"
          className="footer_sm_link"
          target="_blank"
        >
          <img src={Fb} alt="Fb" />
        </a>
        <a
          href="https://www.instagram.com/classplus/"
          rel="noopener noreferrer"
          className="footer_sm_link"
          target="_blank"
        >
          <img src={Instagram} alt="In" />
        </a>
        <a
          href="https://www.youtube.com/channel/UCp0yDDnyu-C-0Bo_y1JbGtA"
          rel="noopener noreferrer"
          className="footer_sm_link"
          target="_blank"
        >
          <img src={YouTube} alt="Yt" />
        </a>
        <a
          href="https://www.linkedin.com/company/classplus/"
          rel="noopener noreferrer"
          className="footer_sm_link"
          target="_blank"
        >
          <img src={LinkedIn} alt="Ln" />
        </a>
        <a
          href="https://twitter.com/ClassplusApps"
          rel="noopener noreferrer"
          className="footer_sm_link"
          target="_blank"
        >
          <img src={Twitter} alt="tw" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
